module.exports = __webpack_public_path__ + "img/dupontAnalyze.c545eee4.png";